import { render } from "./EmailSentView.vue?vue&type=template&id=4e5b2658&scoped=true"
import script from "./EmailSentView.vue?vue&type=script&lang=js"
export * from "./EmailSentView.vue?vue&type=script&lang=js"

import "./EmailSentView.vue?vue&type=style&index=0&id=4e5b2658&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5b2658"]])

export default __exports__